module.exports = __webpack_public_path__ + "img/A2_3.4dd18a29.png";